import {Component, OnDestroy, OnInit} from "@angular/core";
import {NotificationsService} from "angular2-notifications";
import {
  APP_DATE_FORMAT,
  CommonUtility,
  DataService,
  DateUtility,
  EDIT_BTN, ProviderSummary,
  STARTDT_GT_ENDDT,
  WpProvider
} from "../shared";
import {ActivatedRoute, Router} from "@angular/router";
import {ReferenceTableService} from "../reference-table.service";
import {ProviderService} from "./provider-management.service";
import {HttpErrorResponse, HttpResponse} from "@angular/common/http";
import {PageResponse} from "../shared/model/page.model";
import {Observable} from "rxjs/Observable";


@Component({
  selector: 'provider-management',
  templateUrl: './provider-management.component.html',
  styleUrls: ['./provider-management.component.scss']
})

export class ProviderManagementComponent implements OnInit, OnDestroy {

  providers: WpProvider[];
  provider: WpProvider;
  page: PageResponse;

  EDIT_BTN: string = EDIT_BTN;
  userActionNotificationsMap: any;
  noData : boolean;
  toggleSummary: boolean;
  toggleDetails: boolean;
  pageNumber: number;
  pageSize: number;
  errorStartEndDateFields: string = null;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  countyDropdownSettings: any = {};
  activityDropdownSettings: any = {};

  countyCds: Array<any>;
  activityCds:  Array<any>;
  countiesActivitiesCds:  Array<any>;
  countyMap: Map<string, string>;
  activityMap: Map<string, string>;
  countiesActivitiesMap: Map<string, string>;
  validActivityCds:  Array<any>;
  displayedActMap: Map<any,any>;
  selectedCountyItems: Array<any>;
  selectedActivityItems: Array<any>;

  constructor(
    private providerService: ProviderService,
    private route: ActivatedRoute,
    private router: Router,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private dataService: DataService,
    private notificationService: NotificationsService
  ) {
  }

  ngOnInit() {
    this.loadStaticData();
    this.toggleSummary = true;
    this.toggleDetails = false;
    this.providers = new Array<WpProvider>();

    this.pageNumber = 0;
    this.pageSize = 100;
    this.loadPage(this.pageNumber, this.pageSize);

    this.validActivityCds = [];
    this.displayedActMap = new Map();

    this.countyDropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll : false,
    };
    this.selectedCountyItems = [];

    this.activityDropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll : false,
    };
    this.selectedActivityItems = [];
  }

  loadPage(pageNum: number, pageSize: number){
    this.providerService.findAllProviders(pageNum,pageSize).subscribe(
      (res:HttpResponse<any>) => {
        if(res == null || res.body.hasOwnProperty('errorCode')){
          this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
        } else {
          this.page = res.body;
          this.providers = this.page.content;
          this.pageNumber = this.page.number;

          if (this.providers === undefined || this.providers === null || this.providers.length === 0) {
            this.noData = true;
          }
        }
      },(res: HttpErrorResponse) => {
        this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
      },() => {
      }
    );
  }

  togglePages(showPage){
    if ( showPage === 'providerManagementSummary' ) {
      this.toggleSummary = true;
      this.toggleDetails = false;
    } else if(  showPage === 'providerManagementDetails'  ) {
      this.toggleSummary = false;
      this.toggleDetails = true;
    }
  }

  loadProviderDetails(provider: WpProvider){
    if(provider != null){
      this.formatDatesFromServer(provider);
      this.formatCodesFromServer(provider);
      this.getValidActivitiesPerCounty(provider.counties, provider);
      this.selectCountiesAndActivities(provider);
      this.provider = provider;
    }else{
      this.provider = new WpProvider();
    }
  }

  formatDatesFromServer(provider: WpProvider){
    if(provider.contractBeginDt != null){
      provider.contractBeginDt = this.dateUtil.convertDateFromServer(provider.contractBeginDt);
    }
    if(provider.contractEndDt != null){
      provider.contractEndDt = this.dateUtil.convertDateFromServer(provider.contractEndDt);
    }
  }

  formatCodesFromServer(provider: WpProvider) {
    if (provider.counties != null && provider.counties.trim().length > 0){
      provider.counties = provider.counties.split(',');
    } else {
      provider.counties = [];
    }

    if (provider.activities != null && provider.activities.trim().length > 0){
      provider.activities = provider.activities.split(',');
    } else {
      provider.activities = [];
    }
  }

  selectCountiesAndActivities(provider: WpProvider){
    for (let countyStr of provider.counties){
      for (let county of this.countyCds) {
        if (countyStr === county.value){
          this.selectedCountyItems.push(county);
          break;
        }
      }
    }

    if(!this.validActivityCds || this.validActivityCds.length === 0){ return; }

    for (let activityStr of provider.activities){
      for (let activity of this.validActivityCds) {
        if (activityStr === activity.value){
          this.selectedActivityItems.push(activity);
          break;
        }
      }
    }
  }

  save() {
    if (!this.validDates()) {
      return;
    }
    this.setProviderKeyWords();
    this.formatDatesForServer();
    this.formatCodesForServer();
    const pageNum = this.provider.id > 0 ? this.pageNumber : (this.page.totalPages > 0 ? this.page.totalPages - 1 : 0);
    const providerSummary:ProviderSummary = new ProviderSummary(this.provider, null, pageNum, this.pageSize);
    this.subscribeToSaveResponse(this.providerService.save(providerSummary));
  }

  validDates(){
    if( this.provider.contractBeginDt !== undefined
      && this.provider.contractBeginDt !== null
      && this.provider.contractEndDt !== undefined
      && this.provider.contractEndDt !== null){
      let startDt = new Date(this.provider.contractBeginDt.year,
        this.provider.contractBeginDt.month-1,
        this.provider.contractBeginDt.day);
      let endDt = new Date(this.provider.contractEndDt.year,
        this.provider.contractEndDt.month-1,
        this.provider.contractEndDt.day)

      if(startDt > endDt){
        this.errorStartEndDateFields = STARTDT_GT_ENDDT;
        return false;
      }else{
        this.errorStartEndDateFields = null;
      }
    }

    return true;
  }

  formatDatesForServer(){
    if(this.provider.contractBeginDt != null){
      this.provider.contractBeginDt = this.dateUtil.convertDateForServer(this.provider.contractBeginDt);
    }

    if(this.provider.contractEndDt != null){
      this.provider.contractEndDt = this.dateUtil.convertDateForServer(this.provider.contractEndDt);
    }
  }

  formatCodesForServer(){
    let codes: any = '';

    if(this.provider.counties !== undefined && this.provider.counties !== null){
      for (let s of this.provider.counties) {
        codes += s + ',';
      }
      codes = codes.substring(0, codes.length - 1);
      this.provider.counties = codes;
    }

    codes = '';
    if(this.provider.activities !== undefined && this.provider.activities !== null){
      for (let s of this.provider.activities) {
        codes += s + ',';
      }
      codes = codes.substring(0, codes.length - 1);
      this.provider.activities = codes;
    }
  }

  setProviderKeyWords(){
    let keyWords: any = '';
    if(this.provider.activities !== undefined && this.provider.activities !== null){
      for (let s of this.provider.activities) {
        keyWords += (this.convertCode(this.activityMap, s) + ',');
      }
      keyWords = keyWords.substring(0, keyWords.length - 1);
    }
    this.provider.keyword = keyWords;
  }

  private subscribeToSaveResponse(result: Observable<HttpResponse<ProviderSummary>>) {
    result.subscribe(
      (res: HttpResponse<ProviderSummary>) => {
        if(res == null || res.body.hasOwnProperty('errorCode')){
          this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
        } else {
          this.onSaveSuccess(res.body)
        }
      },
      (res: HttpErrorResponse) => {
      this.notificationService.error('Provider', this.userActionNotificationsMap.ERROR);
      },() => {
      }
    );
  }

  private onSaveSuccess(result: ProviderSummary) {
    this.noData = false;
    this.provider = new WpProvider();
    this.page = result.page;
    this.providers = this.page.content;
    this.pageNumber = this.page.number;
    this.validActivityCds = [];
    this.selectedCountyItems = [];
    this.selectedActivityItems = [];
    this.togglePages('providerManagementSummary');

    //Display success notification
    this.notificationService.success('Provider', this.userActionNotificationsMap.UPDATE);
  }

  formatProviderForServer(){

    if(this.provider != null){
      if(this.provider.contractBeginDt != null){
        this.provider.contractBeginDt = this.dateUtil.convertDateForServer(this.provider.contractBeginDt);
      }
      if(this.provider.contractEndDt != null){
        this.provider.contractEndDt = this.dateUtil.convertDateForServer(this.provider.contractEndDt);
      }

      this.formatCodesForServer();
    }
  }

  onCountiesChange(values:Array<string>){
    this.getValidActivitiesPerCounty(values,this.provider);
  }

  getValidActivitiesPerCounty(selectedCounties:Array<string>, provider:WpProvider){
    let countyActivities: Array<string>;
    let selectedActivities: Array<string> = provider.activities ? provider.activities : [];
    let selectedActCopy: Array<string> = [];
    this.displayedActMap = new Map();
    this.validActivityCds = [];

    for (let countyCd of selectedCounties){

      countyActivities = this.countiesActivitiesMap.get(countyCd).split(',');

      for (let activityStr of countyActivities){
        if (this.displayedActMap.has(activityStr)) {
          continue;
        } else {
          this.displayedActMap.set(activityStr,'');
        }

        for (let activity of this.activityCds){
          if(activity.value === activityStr){
            this.validActivityCds.push(activity);
            break;
          }
        }
      }
    }

    for (let activity of selectedActivities){
      if(this.displayedActMap.has(activity)){
        selectedActCopy.push(activity);
      }
    }

    provider.activities = selectedActCopy;
  }

  reset(){
    this.errorStartEndDateFields = null;
    this.validActivityCds = [];
    this.selectedCountyItems = [];
    this.selectedActivityItems = [];
  }

  onItemSelect(item: any){
    let selectedCounties: Array<string> = this.provider.counties ? this.provider.counties : [];
    selectedCounties.push(item.value);
    this.provider.counties = selectedCounties;
    this.getValidActivitiesPerCounty(selectedCounties,this.provider);
  }

  onItemDeSelect(item: any){
    let selectedCounties: Array<string> = this.provider.counties ? this.provider.counties : [];

    for (let i = 0; i < selectedCounties.length; i++){
      if (selectedCounties[i] === item.value) {
        selectedCounties.splice(i, 1);
        break;
      }
    }

    this.provider.counties = selectedCounties;
    this.getValidActivitiesPerCounty(selectedCounties,this.provider);
  }

  onSelectAll(items: any){
    for(let item of items){
      this.onItemSelect(item);
    }
  }

  onDeSelectAll(items: any){
    this.provider.counties = [];
    this.provider.activities = [];
    this.selectedCountyItems = [];
    this.selectedActivityItems = [];
  }

  onActivityItemSelect(item: any){
    let selectedActivities: Array<string> = this.provider.activities ? this.provider.activities : [];
    selectedActivities.push(item.value);
    this.provider.activities = selectedActivities;
  }

  onActivityItemDeSelect(item: any){
    let selectedActivities: Array<string> = this.provider.activities ? this.provider.activities : [];

    for (let i = 0; i < selectedActivities.length; i++){
      if (selectedActivities[i] === item.value) {
        selectedActivities.splice(i, 1);
        break;
      }
    }

    this.provider.activities = selectedActivities;
  }

  onActivitySelectAll(items: any){
    for(let item of items){
      this.onActivityItemSelect(item);
    }
  }

  onActivityDeSelectAll(items: any){
    this.provider.activities = [];
    this.selectedActivityItems = [];
  }

  loadStaticData(){
    this.data.currentMessage.subscribe(
      (message) => {
        if(message === null || message === "") this.data.loadData();
      });

    this.data.currentMessage.subscribe(
      (message) => {
        this.parseRefTableData(message);
      });
  }

  parseRefTableData(myData){
    if(myData != undefined && myData.englishDropDown){
      this.countyCds = myData.englishDropDown['COUNTIES'];
      this.activityCds = myData.englishDropDown['PROVIDERACTIVITIES'];
      this.countiesActivitiesCds = myData.englishDropDown['COUNTIESACTIVITIES'];

      this.countyMap = this.commonUtil.createMapFromList(this.countyCds);
      this.activityMap = this.commonUtil.createMapFromList(this.activityCds);
      this.countiesActivitiesMap = this.commonUtil.createMapFromList(this.countiesActivitiesCds);
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);

      if(this.countyCds[0].value === undefined){
        this.countyCds.shift(); //Remove value at index 0
      }

      if(this.activityCds[0].value === undefined){
        this.activityCds.shift(); //Remove value at index 0
      }

      if(this.countiesActivitiesCds[0].value === undefined){
        this.countiesActivitiesCds.shift(); //Remove value at index 0
      }
    }
  }

  convertCode(myMap, code){
    if(myMap != undefined){
      return myMap.get(code);
    }
  }

  counter(i: number){
    return new Array(i);
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/app/provider-management/provider-management.component.ts